module.exports = __webpack_public_path__ + "img/de.c460c0fc.svg";